import type { ReactElement } from 'react';
import type { Control, ControllerRenderProps, FieldPath, FieldValues } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

export type VyFormFieldProps<TFieldValues extends FieldValues = FieldValues> = {
  name: FieldPath<TFieldValues>;
  control?: Control<TFieldValues>;
  disabled?: boolean;
  children: (
    field: ControllerRenderProps<TFieldValues, FieldPath<TFieldValues>>,
    fieldState: { error?: { message?: string } },
  ) => ReactElement;
};

export const VyFormField = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  disabled,
  children,
}: VyFormFieldProps<TFieldValues>) => {
  const formContext = useFormContext<TFieldValues>();
  const formControl = control || formContext.control;

  if (!formControl) {
    throw new Error('VyFormField must be used within a FormProvider or with a control prop');
  }

  return (
    <Controller
      control={formControl}
      name={name}
      disabled={disabled}
      render={({ field, fieldState }) => children(field, fieldState)}
    />
  );
};
